package com.starparty.app.astro0

import com.starparty.app.vector_maths.Matrix4d
import com.starparty.app.vector_maths.Point2d
import com.starparty.app.vector_maths.Point3d

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
class Circle(
    protected val isLatLine: Boolean,
    protected val itsConstOrd: Double
) {
    protected val itsNumOfPoints: Int = 80
    protected val carts: Array<Point3d> = Array(itsNumOfPoints) { i -> Point3d() }
    var projectedPoints: Array<Point2d> = Array(itsNumOfPoints) { i -> Point2d()}

    protected fun makeCartesianPoints() {

        val spacing = 360.0 / itsNumOfPoints
        val point = Point3d()

        for (p in 0 until itsNumOfPoints) {
            val pDeg = p * spacing
            if (isLatLine) {
                SphericalCoords.Companion.sphericalToCartesian(pDeg, itsConstOrd, point)
            } else {
                SphericalCoords.Companion.sphericalToCartesian(itsConstOrd, pDeg, point)
            }
            carts[p].set(point.x, point.y, point.z)
        }
    }

    fun project(m: Matrix4d) {
        for (p in projectedPoints.indices) {
            val projPoint = Projection.Companion.projectFromMatrix(carts[p], m)
            projectedPoints[p].set(projPoint.x, projPoint.y)
        }
    }

    init {
        makeCartesianPoints()
    }
}